import React from "react";
import { string, node } from "prop-types";

const ContentContainer = ({ title, children, ...props }) => (
  <div className="flex flex-col gap-4 self-start ml-4 mt-1 pb-8" {...props}>
    <h2 className="text-primaryDark text-xl uppercase font-semibold">
      {title}
    </h2>
    {children}
  </div>
);

ContentContainer.propTypes = {
  children: node,
  title: string,
};

export default ContentContainer;
